const LogoIcon = ({
    color = "#FFFFFF",
    width = 50,
    height = 40,
    ...rest
}: {
    color?: string
    width?: number
    height?: number
    [key: string]: any
}) => (
    <svg {...rest} width={width} height={height} viewBox="0 0 50 40" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path d="M0 23.4429C0 22.6511 0.641947 22.0091 1.43383 22.0091H32.2987C33.0906 22.0091 33.7325 22.6511 33.7325 23.4429C33.7325 32.2416 26.5998 39.3744 17.8011 39.3744H15.9314C7.13274 39.3744 0 32.2416 0 23.4429Z" />
        <path d="M47.5776 8.74688C48.6493 9.36008 48.6493 10.9056 47.5776 11.5188L35.773 18.2728C34.7085 18.8819 33.3832 18.1133 33.3832 16.8868L33.3832 3.3789C33.3832 2.15245 34.7085 1.38385 35.773 1.99291L47.5776 8.74688Z" />
    </svg>
)

export default LogoIcon
